import { Group as ApiGroup, fetchGroup as apiFetchGroup } from 'api/groups';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch, GetState } from '..';
import { setError } from './error';

// Types

export type Group = ApiGroup & {
  isFetching: boolean;
};
export type State = {
  byId: Record<string, Group>;
};

type FetchGroupRequestAction = {
  type: 'FETCH_GROUP_REQUEST';
  groupId: string;
};
type FetchGroupSuccessAction = {
  type: 'FETCH_GROUP_SUCCESS';
  group: ApiGroup;
};
type SetGroupUnpublishedAction = {
  type: 'SET_GROUP_UNPUBLISHED';
  groupId: string;
  isUnpublished: boolean;
};
export type Action =
  | FetchGroupRequestAction
  | FetchGroupSuccessAction
  | SetGroupUnpublishedAction;

// Reducer

export default function groupsReducer(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = {
    byId: {},
  },
  action: Action
) {
  switch (action.type) {
    case 'FETCH_GROUP_REQUEST':
      return {
        byId: {
          ...state.byId,
          [action.groupId]: {
            ...state.byId[action.groupId],
            id: action.groupId,
            isFetching: true,
          },
        },
      };

    case 'FETCH_GROUP_SUCCESS':
      return {
        byId: {
          ...state.byId,
          [action.group.id]: { ...action.group, isFetching: false },
        },
      };

    case 'SET_GROUP_UNPUBLISHED':
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.groupId]: {
            isFetching: false,
            isUnpublished: true,
          },
        },
      };

    default:
      // this causes a flow error if there are any unhandled actions
      action as never;

      return state;
  }
}

// Actions

const fetchGroupRequest = (groupId: string): FetchGroupRequestAction => ({
  type: 'FETCH_GROUP_REQUEST',
  groupId,
});

const fetchGroupSuccess = (group: ApiGroup): FetchGroupSuccessAction => ({
  type: 'FETCH_GROUP_SUCCESS',
  group,
});

const setGroupUnpublished = (
  groupId: string,
  isUnpublished: boolean
): SetGroupUnpublishedAction => ({
  type: 'SET_GROUP_UNPUBLISHED',
  groupId,
  isUnpublished,
});

export const fetchGroup =
  (groupId: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const group = state.groups.byId[groupId];

    if (!group) {
      dispatch(fetchGroupRequest(groupId));
      apiFetchGroup(groupId)
        .then((fetchedGroup) => {
          dispatch(fetchGroupSuccess(fetchedGroup));
        })
        .catch((e) => {
          if (e.statusCode !== 404) {
            dispatch(setError(e));
          } else {
            dispatch(setGroupUnpublished(groupId, true));
          }
        });
    }
  };

export const updateGroup = fetchGroupSuccess;
